import React from "react";
import Select from "../MultiSelect";
import { FormHelperText } from "@material-ui/core";
import { getIn } from "formik";
import FormControl from "@material-ui/core/FormControl";

export default function({
  field,
  form,
  onChange,
  onBlur,
  variant,
  options,
  isClearable,
  placeholder,
  value,
  helperText,
  formatOptionLabel,
  displayErrorMessage = true,
  ...otherProps
}) {
  const changeHandler = evt => {
    form.setFieldValue(field.name, evt);
    if (onChange) {
      onChange(evt);
    }
  };

  const blurHandler = event => {
    form.setFieldTouched(field.name);
    if (onBlur) {
      onBlur(event);
    }
  };
  const touch = getIn(form.touched, field.name);
  const errorText = getIn(form.errors, field.name);

  return (
    <>
        <FormControl variant="filled">
          <Select
            {...otherProps}
            value={field.value}
            formatOptionLabel = {formatOptionLabel}
            onChange={changeHandler}
            onBlur={blurHandler}
            options={options}
            isSearchable = {true}
            textFieldProps={{
              variant: variant,
              label: placeholder
            }}
            placeholder=""
            isClearable={isClearable}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 99999 }),
              dropdownIndicator: (provided, state) => ({
                ...provided,
                transform: state.selectProps.menuIsOpen && 'rotate(180deg)'
              })
            }}
          />
        </FormControl>

      {displayErrorMessage ? (
        <FormHelperText error={Boolean(touch && errorText)}>
          {(touch && errorText) || helperText}
        </FormHelperText>
      ) : (
        helperText && <FormHelperText>{helperText}</FormHelperText>
      )}
    </>
  );
}
